import { render, staticRenderFns } from "./AlboSTP.vue?vue&type=template&id=5acac1c3&"
import script from "./AlboSTP.vue?vue&type=script&lang=ts&"
export * from "./AlboSTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports